import { cn } from '../../lib/cn';
import type { RevenueRow } from '../../enterprisega/framework';

type Props = { metrics?: RevenueRow[] };

export function RevenueOperationsPanel({ metrics = [] }: Props) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {metrics.map((m) => (
        <div key={m.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{m.metric}</p>
          <p className="mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{m.value}</p>
          <div className="mt-1 flex items-center gap-2">
            <span className={cn(
              'text-xs font-medium',
              m.change.startsWith('+') || m.change.startsWith('-') && m.metric === 'CAC' || m.metric === 'Churn'
                ? 'text-success-600' : 'text-brand-600',
            )}>
              {m.change}
            </span>
            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{m.status}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
